
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/[highlights]",
      function () {
        return require("private-next-pages/inspiration/[highlights].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/[highlights]"])
      });
    }
  